import { CarouselItemId } from '@homex/se-widget-flow-types';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components/macro';

import { CarouselItemAddressBottom } from 'components/CarouselItemAddressBottom';
import { IState, RepairAddressCarouselItem } from 'typings';
import { tryGetFlowCarouselItem } from 'utils/tryGetFlowCarouselItem';

export const CAROUSEL_ITEM_ID = CarouselItemId.RepairAddress;

export const CarouselItemAddressRepairBottom = () => {
  const { flowCarouselItem } = useSelector((state: IState) => ({
    flowCarouselItem: tryGetFlowCarouselItem<RepairAddressCarouselItem>(
      state.client.flow,
      CAROUSEL_ITEM_ID,
    ),
  }));
  const theme = useTheme();

  let correctionNeededDestinationId;
  let matchFoundDestinationId;
  let matchNotFoundDestinationId;

  if (flowCarouselItem) {
    correctionNeededDestinationId =
      flowCarouselItem.options.destinations.correctionNeeded;
    matchFoundDestinationId = flowCarouselItem.options.destinations.next;
    matchNotFoundDestinationId =
      flowCarouselItem.options.destinations.matchNotFound;
  } else {
    correctionNeededDestinationId = CarouselItemId.RepairAddressCorrection;
    matchFoundDestinationId = theme.schedulePreferenceEnabled
      ? CarouselItemId.SchedulePreference
      : CarouselItemId.ScheduleCalendarRepair;
    matchNotFoundDestinationId = CarouselItemId.RepairAddressNotFound;
  }

  return (
    <CarouselItemAddressBottom
      addressDisclaimerEnabled={
        flowCarouselItem?.options.addressDisclaimerEnabled
      }
      correctionNeededDestinationId={correctionNeededDestinationId}
      matchFoundDestinationId={matchFoundDestinationId}
      matchNotFoundDestinationId={matchNotFoundDestinationId}
      parentCarouselItemId={CAROUSEL_ITEM_ID}
    />
  );
};
